
import { ref, reactive, watchEffect, inject } from "vue";
import unwind from "./unwind.vue";
import servicer from "./servicer.vue";
import { Toast } from "vant";
import { useRoute } from 'vue-router'

export default {
  components: {
    unwind,
    servicer,
  },
  props: {
    stringFacets: { type: Array, default: () => ([]) },
    category: {
      type: Object,
    },
    brands: {
      type: Array,
    },
    popupClick: {
      type: Function,
      default: () => {},
    },
    gc_id:{
      type:String || Number
    },
    shipped:{
      type:Array
    }
  },
  setup(props: any, { emit }: any) {
    console.log('12345props',props);
    
    let $store:any = inject('$store')
    let route = useRoute();
    let careGc_id =  route.query.bind_cid ? route.query.bind_cid : '';
    let unCategory = ref<Number>(-1)
    let unBrand = ref<Number>(-1)
    let careBrand_id = route.query.brand_id ? route.query.brand_id : '';
    //data数据
    const status = ref(false),
          refsUnwind = ref(),
          refsUnwindTow = ref(),
          refShipped = ref(),
          refService = ref();
    const serviceList = reactive([
      {
        type: "Free Shipping",
        id: 1,
      },
      {
        type: "Have Gift",
        id: 2,
      },
    ]);
    //价格
    const modelMix = ref(route.query.min ? route.query.min : '');
    const modelMax = ref(route.query.max ? route.query.max : '');
    const modelMaxClick = () => {
      if (modelMax.value < modelMix.value) {
        Toast("Max cannot be less than Mix");
      }
    };
    const cloneClick = (val: string) => {
      if (val === "Reset") {
         refsUnwind.value.remove_clones()
         refsUnwindTow.value.remove_clones()
         refShipped.value.remove_clones()
         refService.value.clone_class()
         modelMix.value = ''
         modelMax.value = ''
        emit("popupClick", "clone");   
         emit('clear')   
      } else {
        emit("popupClick", { min: modelMix.value, max: modelMax.value });
       
      }
    };
    const transferData: any = reactive({
      list: [],
      brands: [],
    });
    let negation = ref(true)


    const categoryList = ref<any>([])
    const brandList = ref<any>([])
    const handleFormatFacets = () => {
      const categoryInfo = props.stringFacets.find((c: any) => c.facet_type === 'category')
      const brandInfo = props.stringFacets.find((c: any) => c.facet_type === 'brand')

      if(categoryInfo) {
        categoryList.value = categoryInfo.facet_value.map((name: string) => ({ name, id: name }))
      }
      if(brandInfo) {
        brandList.value = brandInfo.facet_value.map((name: string) => ({ name, id: name }))
      }

      console.log('---------stringFacets: ', categoryList.value, brandList.value)
    }
    //watch监听
    watchEffect(() => {  
      console.log('category ---: ', props.category)
      handleFormatFacets()

    //   transferData.list = props.category.category.children ? props.category.category.children : [];
    //    if(props.category.category.children && props.category.category.children.length > 0){       
    //          if($store.getCategory() ==null){
    //              $store.setCategory(props.category.category.children) 
    //          }else if(props.category.category.children.length != $store.getCategory().length){
    //             $store.getGcId()
    //             if(negation){      
    //               negation.value = false
    //                $store.setCategory(props.category.category.children)
    //                if(refsUnwind.value){
    //                     refsUnwind.value.remove_clones()
    //                }                   
    //             }
    //          }else{       
    //             $store.setCategory(props.category.category.children) 
    //          }
    //   }  
    
    //   props.category.attributes.brands.forEach((element: any,index:Number) => {
    //     element.name = element.brand_name;
    //     element.id = element.brand_id;
    //     if(careBrand_id ==element.brand_id){
    //        unBrand.value = index
    //     }

       
    //   });

    //  transferData.list.forEach((e:any,index:Number) => {
    //    if(careGc_id == e.id){
    //      unCategory.value = index
    //      console.log('我会执行吗',unCategory.value);
         
    //    }
    //  });

    //   transferData.brands = props.category.attributes.brands
    //   console.log('transferData: ', transferData)
    });

    return {
      status,
      modelMix,
      modelMax,
      transferData,
      serviceList,
      modelMaxClick,
      cloneClick,
      refsUnwind,
      refsUnwindTow,
      refShipped,
      refService,
      unCategory,
      unBrand,
      brandList,
      categoryList
    };
  },
};
